import { Component, OnInit } from '@angular/core';
import { QualityService } from '../../../models/quality-service.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { VesselType } from 'src/app/front-user/shared/models/vessel-type.modal';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AttachmentType, QualityServices, NearestLocation, Service, BaseTypeId, Languages, KWUnit, MaterialThicknessUnit, AcceptanceCriteriaOthers, EquipementTypeOthers } from 'src/app/shared/models/enums.model';
import { AcceptanceCriteria } from '../../../models/acceptence-criteria.model';
import { HttpResponse, HttpEventType } from '@angular/common/http';
import { Attachment } from 'src/app/front-user/shared/models/attachment.model';
import { fileService } from 'src/app/front-user/shared/services/file.service';
import { TranslateService } from '@ngx-translate/core';
import { EquipmentType } from '../../../models/machine-type.model';
import { TypeOfMagent } from '../../../models/type-of-magent.model';
import { MaterialForm } from '../../../models/material-form.model';
import { FilmType } from '../../../models/film-type.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { QualityRequestDTO } from '../../../models/quality-Request-DTO.model';
import { QualityRequestService } from '../../../services/quality-request.service';
import { ActivatedRoute } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { CustomValidators } from '../../../models/custom-validator';
import { FileValidator } from 'src/app/front-user/shared/validator/file-input.validator';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { AppConfig } from 'src/app/shared/services/app.config';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-non-destructive-testing-work',
  templateUrl: './non-destructive-testing-work.component.html',
  styleUrls: ['./non-destructive-testing-work.component.css']
})
export class NonDestructiveTestingWorkComponent implements OnInit {
  nonDestructiveTestingWorkForm: FormGroup;
  qualityService: QualityService[];
  vesselType: VesselType[];
  equipmentType: EquipmentType[];
  acceptanceCriteria: AcceptanceCriteria[];
  typeOfMagent: TypeOfMagent[];
  public QualityServices: any = QualityServices;
  materialForm: MaterialForm[];
  filmType: FilmType[];
  executiveDrawingsProgress: number;
  DrawingsProgress: number;
  attachments: Attachment[] = [];
  baseType = BaseTypeId;
  baseTypeKeys = Object.keys(this.baseType);
  submitted = false;
  responseObject: ResponseObject;
  qualityRequest: QualityRequestDTO;
  loading = false;
  testedDiv: number;
  nearestLocation = NearestLocation;
  nearestLocationKeys = Object.keys(this.nearestLocation);
  requestId: any;
  isReadOnly: boolean;
  qualityRequestDTO: QualityRequestDTO;
  drawingAttachmentUrl;
  displayedLang: string;
  kwUnit = KWUnit;
  kwUnitKeys = Object.keys(this.kwUnit);
  materiallThiknessUnit = MaterialThicknessUnit;
  materiallThiknessUnitKeys = Object.keys(this.materiallThiknessUnit);
  numberRegex: string = '^[0-9]*$';
  floatRegx: string = '^[0-9]+(\.[0-9]{0,20})?$';
  charRegex: string = '^[a-zA-Z\\s]*$';
  showSuccessMessage: boolean;
  showUnsuccessMessage: boolean;
  showOtherDiv: boolean;
  acceptanceCriteriaOthers: AcceptanceCriteriaOthers;
  equipementTypeOthers: EquipementTypeOthers;
  showMachineDiv: boolean;
  showRequest = true;
  responseObj: ResponseObject;
  showDivs: boolean = false;
  mobileRegex: string = '^(\\+[0-9]*)$';
  isErrorMessage: boolean = false;
  userInfo: any;
  baseRequestDTO: BaseRequest;
  drawingAttachmentExist : string;

  constructor(private lookupService: LookupService, private formBuilder: FormBuilder,
    private fileService: fileService,
    private translate: TranslateService,
    private alertService: AlertService,
    private qualityRequestService: QualityRequestService,
    private route: ActivatedRoute,
    private globalSrv: GlobalServices,
    private authSrevice: AuthenticationService
  ) {
    if (history.state.data && history.state.data.requestId)
      this.requestId = history.state.data.requestId;

    // this.requestId = this.route.snapshot.params.Id;
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    this.baseTypeKeys = this.baseTypeKeys.slice(this.baseTypeKeys.length / 2);
    this.nearestLocationKeys = this.nearestLocationKeys.slice(this.nearestLocationKeys.length / 2);
    this.kwUnitKeys = this.kwUnitKeys.slice(this.kwUnitKeys.length / 2);
    this.materiallThiknessUnitKeys = this.materiallThiknessUnitKeys.slice(this.materiallThiknessUnitKeys.length / 2);

    this.buildForm(null);
  }

  ngOnInit() {
    // this.requestId = this.route.snapshot.queryParamMap.get('id');

    this.isReadOnly = this.requestId != null ? true : false;
    if (history.state.data && history.state.data.isCompleted) {
      this.isReadOnly = true;
    }else if((!history.state.data )&&this.authSrevice.currentUserValue.IsAdmin){
      window.history.back();
    }

    // Get Quality SeviceLookup

    this.lookupService.getQualityServices().subscribe(
      d => {
        this.qualityService = d.Data;
      }
    );

    // Get VesselType Lookup
    this.lookupService.getVesselTypes().subscribe(
      d => {
        this.vesselType = d.Data;
      }
    );
    // Get Acceptance Criteria Lokup
    this.lookupService.getAcceptenceCriteria().subscribe(
      d => {
        this.acceptanceCriteria = d.Data;
      }
    );
    // Get Equipmenttype
    this.lookupService.getEquipmentTypes().subscribe(
      d => {
        this.equipmentType = d.Data;
      }
    );

    // Get MagentType
    this.lookupService.getMagentTypes().subscribe(
      d => {
        this.typeOfMagent = d.Data;
      }
    );

    // Get Materialform
    this.lookupService.getMaterialForm().subscribe(
      d => {
        this.materialForm = d.Data;
      }
    );

    // Get filmtype
    this.lookupService.getFilmType().subscribe(
      d => {
        this.filmType = d.Data;
      }
    );

    if (this.requestId) {
      this.getQualityRequest();
    }

  }

  getQualityRequest() {
    this.qualityRequestService.getQualityRequest(this.requestId).subscribe(
      d => {
        this.changeQuality(d.Data.QualityServiceId);
        this.changeCriteria(d.Data.AcceptanceCriteriaId);
        this.changeMachineType(d.Data.MachineTypeId);
        this.qualityRequestDTO = d.Data;
        this.nonDestructiveTestingWorkForm.patchValue({
          QualityServiceId: this.qualityRequestDTO.QualityServiceId,
          VesselTypeId: this.qualityRequestDTO.VesselTypeId,
          AcceptanceCriteriaId: this.qualityRequestDTO.AcceptanceCriteriaId,
          Description: this.qualityRequestDTO.Description,
          DateOfMeasurement: this.qualityRequestDTO.DateOfMeasurement!=null?new Date(this.qualityRequestDTO.DateOfMeasurement):'',
          VesselName: this.qualityRequestDTO.VesselName,
          NearestLocation: this.qualityRequestDTO.NearestLocation,
          MobileNumber: this.qualityRequestDTO.MobileNumber,
          Fax: this.qualityRequestDTO.Fax,
          CustomerName: this.qualityRequestDTO.CustomerName,
          MachineTypeId: this.qualityRequestDTO.MachineTypeId,
          BaseTypeId: this.qualityRequestDTO.BaseTypeId,
          CouplingType: this.qualityRequestDTO.CouplingType,
          RPM: this.qualityRequestDTO.RPM,
          KW: this.qualityRequestDTO.KW,
          KWUnit: this.qualityRequestDTO.KWUnit,
          Details: this.qualityRequestDTO.Details,
          DesiredDate: this.qualityRequestDTO.DesiredDate!=null?new Date(this.qualityRequestDTO.DesiredDate):'',
          Cleaner: this.qualityRequestDTO.Cleaner,
          Penetrant: this.qualityRequestDTO.Penetrant,
          Developer: this.qualityRequestDTO.Developer,
          TypeOfMagnetId: this.qualityRequestDTO.TypeOfMagnetId,
          WhiteBackground: this.qualityRequestDTO.WhiteBackground,
          BlackInk: this.qualityRequestDTO.BlackInk,
          MaterialFormId: this.qualityRequestDTO.MaterialFormId,
          FilmTypeId: this.qualityRequestDTO.FilmTypeId,
          MaterialThickness: this.qualityRequestDTO.MaterialThickness,
          MaterialThicknessUnit: this.qualityRequestDTO.MaterialThicknessUnit,
          OthersAcceptanceCriteria: this.qualityRequestDTO.OthersAcceptanceCriteria,
          OthersMachineType: this.qualityRequestDTO.OthersMachineType
        });

        this.baseRequestDTO = this.qualityRequestDTO.baseRequest;
        this.userInfo = {
          MobileNumber: this.qualityRequestDTO.MobileNumber,
          Fax: this.qualityRequestDTO.Fax,
          CustomerName: this.qualityRequestDTO.CustomerName
        }
        var baseUrl = AppConfig.settings.apiServer.UploadsUrl;
        var shipyardUploadsFolder = AppConfig.settings.apiServer.ShipyardUploadsFolder;
        this.drawingAttachmentUrl = this.qualityRequestDTO.Attachments.find(x => x.AttachmentType == AttachmentType.Drawings) != undefined ?
          this.qualityRequestDTO.Attachments.find(x => x.AttachmentType == AttachmentType.Drawings).URL : '';
        this.drawingAttachmentUrl = baseUrl + shipyardUploadsFolder + "/" + this.drawingAttachmentUrl;
        this.drawingAttachmentExist = this.drawingAttachmentUrl.substring(this.drawingAttachmentUrl.lastIndexOf('/')+1);
      }
    );
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.nonDestructiveTestingWorkForm.controls;
  }

  buildForm(qualityServiceId) {
    if (!qualityServiceId) {
      this.nonDestructiveTestingWorkForm = this.formBuilder.group({
        VesselTypeId: ['undefined', [Validators.required]],
        QualityServiceId: ['undefined', [Validators.required]],
        TermsAndConditions: [false, [Validators.requiredTrue]],
        MobileNumber: ['', [Validators.required]],
        CustomerName: ['', [Validators.required]],
        Fax: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
        VesselName: ['', [Validators.maxLength(50), CustomValidators.textSpaceValidator()]],
        NearestLocation: ['', [Validators.required]]


      });
    }
    else if (qualityServiceId == QualityServices.UltraSonicTest) {

      this.nonDestructiveTestingWorkForm = this.formBuilder.group({
        VesselTypeId: ['undefined', [Validators.required]],
        QualityServiceId: ['undefined', [Validators.required]],
        AcceptanceCriteriaId: ['undefined', [Validators.required]],
        Description: ['', [Validators.required, Validators.maxLength(500), CustomValidators.textSpaceValidator()]],
        Drawings: ['', [FileValidator.validate]],
        DateOfMeasurement: ['', [Validators.required, CustomValidators.dateValidator()]],
        TermsAndConditions: [false, [Validators.requiredTrue]],
        MobileNumber: ['', [Validators.required]],
        Fax: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
        OthersAcceptanceCriteria: [''],
        NearestLocation: ['', [Validators.required]],
        CustomerName: ['', [Validators.required]],
        VesselName: ['', [Validators.maxLength(50), CustomValidators.textSpaceValidator()]]


      });
    }
    else if (qualityServiceId == QualityServices.VibrationTestAndAnalysis) {
      this.nonDestructiveTestingWorkForm = this.formBuilder.group({
        VesselTypeId: ['undefined', [Validators.required]],
        QualityServiceId: ['undefined', [Validators.required]],
        MachineTypeId: ['undefined', [Validators.required]],
        BaseTypeId: ['', [Validators.required]],
        CouplingType: ['', [Validators.required, Validators.maxLength(50), CustomValidators.textSpaceValidator(), /*Validators.pattern(this.charRegex)*/]],
        RPM: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
        KW: ['', [Validators.required, Validators.pattern(this.floatRegx)]],
        KWUnit: [null, [Validators.required]],
        Details: ['', [Validators.required, Validators.maxLength(500), CustomValidators.textSpaceValidator()]],
        NearestLocation: ['', [Validators.required]],
        TermsAndConditions: [false, [Validators.requiredTrue]],
        MobileNumber: ['', [Validators.required]],
        Fax: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
        VesselName: ['', [Validators.maxLength(50), CustomValidators.textSpaceValidator()]],
        OthersMachineType: [''],
        CustomerName: ['', [Validators.required]]


      });
    }
    else if (qualityServiceId == QualityServices.LiquedPenetrantTest) {
      this.nonDestructiveTestingWorkForm = this.formBuilder.group({
        VesselTypeId: ['undefined', [Validators.required]],
        QualityServiceId: ['undefined', [Validators.required]],
        DesiredDate: ['', [Validators.required, CustomValidators.dateValidator()]],
        Description: ['', [Validators.required, Validators.maxLength(500), CustomValidators.textSpaceValidator()]],
        Cleaner: ['', [Validators.maxLength(50), CustomValidators.textSpaceValidator()]],
        Penetrant: ['', [Validators.maxLength(50), CustomValidators.textSpaceValidator()]],
        Developer: ['', [Validators.maxLength(50), CustomValidators.textSpaceValidator()]],
        Drawings: ['',],
        NearestLocation: ['', [Validators.required]],
        TermsAndConditions: [false, [Validators.requiredTrue]],
        MobileNumber: ['', [Validators.required]],
        Fax: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
        VesselName: ['', [Validators.maxLength(50), CustomValidators.textSpaceValidator()]],
        CustomerName: ['', [Validators.required]]





      });
    }
    else if (qualityServiceId == QualityServices.ElectroMagneticTest) {
      this.nonDestructiveTestingWorkForm = this.formBuilder.group({
        VesselTypeId: ['undefined', [Validators.required]],
        QualityServiceId: ['undefined', [Validators.required]],
        DesiredDate: ['', [CustomValidators.dateValidator()]],
        Description: ['', [Validators.maxLength(500), CustomValidators.textSpaceValidator()]],
        TypeOfMagnetId: [null],
        Cleaner: ['', [Validators.maxLength(50), CustomValidators.textSpaceValidator()]],
        WhiteBackground: ['', [Validators.maxLength(50), CustomValidators.textSpaceValidator(), Validators.pattern(this.charRegex)]],
        BlackInk: ['', [Validators.maxLength(50), CustomValidators.textSpaceValidator(), Validators.pattern(this.charRegex)]],
        Drawings: ['',],
        NearestLocation: ['', [Validators.required]],
        TermsAndConditions: [false, [Validators.requiredTrue]],
        MobileNumber: ['', [Validators.required]],
        Fax: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
        VesselName: ['', [Validators.maxLength(50), CustomValidators.textSpaceValidator()]],
        CustomerName: ['', [Validators.required]],

      });

    }
    else if (qualityServiceId == QualityServices.RadioGraphicTest) {

      this.nonDestructiveTestingWorkForm = this.formBuilder.group({
        VesselTypeId: ['undefined', [Validators.required]],
        QualityServiceId: ['undefined', [Validators.required]],
        MaterialFormId: [null],
        FilmTypeId: [null],
        MaterialThickness: ['', [Validators.pattern(this.floatRegx)]],
        MaterialThicknessUnit: [null,],
        NearestLocation: ['', [Validators.required]],
        TermsAndConditions: [false, [Validators.requiredTrue]],
        MobileNumber: ['', [Validators.required]],
        Fax: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
        VesselName: ['', [Validators.maxLength(50), CustomValidators.textSpaceValidator()]],
        CustomerName: ['', [Validators.required]],

      });

    }
  }

  public async onFileSelected(event,currFormControl, docName, attachmentType: AttachmentType, progressVariableName, key) {
    this[progressVariableName] = 0;
    this.alertService.clear();
    let localizationKeyValue = await this.translate.get(key).toPromise();
    if (!this.fileService.IsFileExtentionValid(event)) {
      const formControlName = event.target.attributes.formControlName.value;
      this.nonDestructiveTestingWorkForm.controls[formControlName].setValue('');
      var errorMessage = await this.translate.get('FRONT_USER.Floating_Carnes_Request_Form.NotAllowedFileExtentionMessage').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessage);
      let invalidElements = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      // if (invalidElements && invalidElements.length>0) {
      //   invalidElements[0].scrollIntoView();
      // }
      return false;
    }

    else if (!this.fileService.IsFileSizeValid(event)) {
      const formControlName = event.target.attributes.formControlName.value;
      this.nonDestructiveTestingWorkForm.controls[formControlName].setValue('');
      var errorMessageSize = await this.translate.get('FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessageSize);
      let invalidElement = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      // if (invalidElement && invalidElement.length>0) {
      //   invalidElement[0].scrollIntoView();
      // }
      return false;
    }
    else {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('File', file);
      formData.append('DocumentName', docName);
      formData.append('FolderName', AppConfig.settings.apiServer.ShipyardUploadsFolder);

      this.fileService.fileUploader(formData).subscribe(
        event => {

          if (event.type === HttpEventType.UploadProgress) {
            // This is an upload progress event. Compute and show the % done:
            const percentDone = Math.round(100 * event.loaded / event.total);
            this[progressVariableName] = percentDone;
            currFormControl.setErrors({'invalid': true});
          } else if (event instanceof HttpResponse) {

            const jsonResponse = event.body.Data;
            const Url = jsonResponse.Url;
            const attachment = new Attachment();
            attachment.URL = Url;
            attachment.DocumentName = docName;
            attachment.AttachmentTypeId = attachmentType;
            this.attachments = this.attachments.filter(h => h.DocumentName != docName);
            this.attachments.push(attachment);
            currFormControl.setErrors(null);


          }
        }
      );
    }
  }

  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.nonDestructiveTestingWorkForm.invalid || this.nonDestructiveTestingWorkForm.controls['QualityServiceId'].value == 'undefined' || this.nonDestructiveTestingWorkForm.controls['VesselTypeId'].value == 'undefined' || this.nonDestructiveTestingWorkForm.controls['CustomerName'].invalid/*||this.nonDestructiveTestingWorkForm.controls['MachineTypeId'].value=='undefined'||this.nonDestructiveTestingWorkForm.controls['KWUnit'].value=='null'*/) {
      return;
    }
    if (this.nonDestructiveTestingWorkForm.controls['QualityServiceId'].value == QualityServices.UltraSonicTest) {
      if (this.nonDestructiveTestingWorkForm.invalid || this.nonDestructiveTestingWorkForm.controls['AcceptanceCriteriaId'].value == 'undefined') {
        return;
      }
    }
    if (this.nonDestructiveTestingWorkForm.controls['QualityServiceId'].value == QualityServices.VibrationTestAndAnalysis) {
      if (this.nonDestructiveTestingWorkForm.invalid || this.nonDestructiveTestingWorkForm.controls['MachineTypeId'].value == 'undefined' || this.nonDestructiveTestingWorkForm.controls['KWUnit'].value == 'null') {
        return;
      }

    }





    //Enable Loader
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.qualityRequest = this.nonDestructiveTestingWorkForm.getRawValue();
    this.qualityRequest.Attachments = this.attachments;
    this.qualityRequest.ServiceId = Service.NonDestructiveTestingWork;
    this.qualityRequest.RequestorId = this.authSrevice.currentUserValue.UserId;
    this.qualityRequest.MobileNumber = this.nonDestructiveTestingWorkForm.controls.MobileNumber.value;
    this.qualityRequest.Drawings = this.attachments.length !== 0 ? this.attachments[0].URL : "";


    this.qualityRequestService.addQualityRequest(this.qualityRequest)
      .subscribe(
        (data: ResponseObject) => {

          this.responseObj = data;
          if (this.responseObj.Success) {
            let message: string;
            this.nonDestructiveTestingWorkForm.reset();
            this.showRequest = false;
            this.loading = false;
            //Disable Loader
            this.globalSrv.isLoaderEnabled = false;
            // console.log("Success");
          }
          else {
            this.loading = false;
            this.isErrorMessage = true;
            this.showRequest = false;
            //Disable Loader
            this.globalSrv.isLoaderEnabled = false;
            // console.log("Fail");
          }

        });
  }

  changeQuality(value) {
    let MobileNumberValue;
    if (this.nonDestructiveTestingWorkForm.controls.MobileNumber.value != null) {
      MobileNumberValue = this.nonDestructiveTestingWorkForm.controls.MobileNumber.value;

    }
    let FaxValue = this.nonDestructiveTestingWorkForm.controls.Fax.value;
    let CustomerNameValue = this.nonDestructiveTestingWorkForm.controls.CustomerName.value;
    this.buildForm(value);
    this.nonDestructiveTestingWorkForm.patchValue({
      QualityServiceId: value,
      MobileNumber: MobileNumberValue,
      Fax: FaxValue,
      CustomerName: CustomerNameValue,
    });
    this.nonDestructiveTestingWorkForm.updateValueAndValidity();
    this.testedDiv = value;
    if (this.testedDiv && this.testedDiv.toString() !== 'undefined') {
      this.showDivs = true;
      this.showOtherDiv = false;
      this.showMachineDiv = false;
    } else {
      this.showDivs = false;
      this.showOtherDiv = true;
      this.showMachineDiv = true;
    }
  }

  changeCriteria(value) {
    this.acceptanceCriteriaOthers = value;
    // this.nonDestructiveTestingWorkForm.patchValue({
    //   OthersAcceptanceCriteria: value,
    // });
    if (this.acceptanceCriteriaOthers == AcceptanceCriteriaOthers.Others) {
      if (this.nonDestructiveTestingWorkForm && this.nonDestructiveTestingWorkForm.get('OthersAcceptanceCriteria')) {
        this.nonDestructiveTestingWorkForm.get('OthersAcceptanceCriteria').setValidators([Validators.required]);
        this.nonDestructiveTestingWorkForm.updateValueAndValidity();
      }
      this.showOtherDiv = true;
    }
    else {
      if (this.nonDestructiveTestingWorkForm && this.nonDestructiveTestingWorkForm.get('OthersAcceptanceCriteria')) {
        this.nonDestructiveTestingWorkForm.get('OthersAcceptanceCriteria').setValidators(null);
        this.nonDestructiveTestingWorkForm.controls.OthersAcceptanceCriteria.reset();
        this.nonDestructiveTestingWorkForm.updateValueAndValidity();
      }
      this.showOtherDiv = false;
    }

  }

  changeMachineType(value) {
    // this.nonDestructiveTestingWorkForm.patchValue({
    //   OthersMachineType: value,
    // });
    this.equipementTypeOthers = value;
    if (this.equipementTypeOthers == EquipementTypeOthers.Others) {
      if (this.nonDestructiveTestingWorkForm && this.nonDestructiveTestingWorkForm.get('OthersMachineType')) {
        this.nonDestructiveTestingWorkForm.get('OthersMachineType').setValidators([Validators.required]);
        this.nonDestructiveTestingWorkForm.updateValueAndValidity();
      }
      this.showMachineDiv = true;
    }
    else {
      if (this.nonDestructiveTestingWorkForm && this.nonDestructiveTestingWorkForm.get('OthersMachineType')) {
        this.nonDestructiveTestingWorkForm.get('OthersMachineType').setValidators(null);
        this.nonDestructiveTestingWorkForm.controls.OthersMachineType.reset();

        this.nonDestructiveTestingWorkForm.updateValueAndValidity();
      }
      this.showMachineDiv = false;
    }
  }

  goToTermsAndConditions(): void {
    if (this.globalSrv.getLanguage() == Languages.Arabic)
        window.open(AppConfig.settings.apiServer.ShipyardTermsAR, '_blank');
    else
        window.open(AppConfig.settings.apiServer.ShipyardTermsEN, '_blank');
  }
}
